var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 90,
    viewBox: "0 0 83 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.409 7.48259L1 8.22767L1.22357 72.2345L2.04321 71.3404L4.50215 72.7561L7.70621 72.309L13.2202 79.6858L19.5538 81.0271L20.6715 83.7096L26.26 82.2938L30.8053 84.2311L37.0644 80.729L38.1076 84.5292L42.3548 87.8078L42.7274 89L47.5708 88.6274L48.614 85.1253L50.7748 83.9331L49.8062 80.3565L52.4141 74.917L53.9789 74.6935L56.0653 77.5995L58.4497 76.1837L57.8536 72.4581L60.238 68.2853L62.1008 68.5834L62.0263 66.4225L64.1127 64.9322L66.5716 66.4225L74.2465 59.9398L79.7605 44.2176L80.2075 39.2252L78.7918 35.7231L81.5488 34.3073V1L67.0187 6.66294L59.5674 13.1456L54.0534 13.0711L44.7393 16.3497L39.5233 14.4123L36.2448 15.0829L36.3938 13.5927L39.5979 12.2514L37.9586 11.2082L35.7232 12.5495L32.5191 10.016L26.409 7.48259Z",
    fill: "#273137",
    fillOpacity: 0.1,
    stroke: "#273137",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOh);
export default __webpack_public_path__ + "static/media/OH.9972be7f6ab9f98459f985a7651d5f3e.svg";
export { ForwardRef as ReactComponent };